import {Injectable, Injector} from '@angular/core';
import {AuthorityBaseService} from './authority-base.service';
import {Observable, throwError} from 'rxjs';
import {catchError, map, tap} from 'rxjs/operators';
import {ResponseContentType} from '@angular/http';
import {Utilities} from '@shared/utilities/utilities.model';
import {DateUtilities} from '@shared/utilities/date-utilities.model';
import {LoaderService} from '@shared/service/loader.service';
import { MessageManagerUtilities } from '@shared/service/message-manager/message-manager-utilities';
import { DossierModel } from '../models/dossier.model';
import { PartsOrderModel } from '../models/parts-order.model';
import { QuotationModel } from '@app/authority/authority-op/models/quotation.model';
import { CarglassRequestDetail } from '@app/authority/authority-ald/models/glass-request-detail.model';

@Injectable({
	providedIn: 'root'
})
export class DocumentsService extends AuthorityBaseService {

	private registration_certificate: string = 'Carta_di_circolazione';


	constructor(
		protected injector: Injector,
		protected loaderService: LoaderService
	) {
		super(injector);
	}


	// getBaseURL(x: EModuleType, dossier?: DossierModel | QuotationModel | PartsOrderModel): string {
	// 	return dossier && dossier.isArchived() ? this.environment.api[x].historical.v1 : this.environment.api[x].v1;
	// }
	getBaseURL(type: EModuleType, x?: boolean | DossierModel | QuotationModel | PartsOrderModel | CarglassRequestDetail): string {

		if (Utilities.isEmpty(x) || x === false) {
			return this.environment.api[type].v1;
		}

		if (x == true) {
			return this.environment.api[type].historical.v1;
		}
		
		if (x instanceof DossierModel || x instanceof QuotationModel || x instanceof PartsOrderModel) {
			return x && x.isArchived() ? this.environment.api[type].historical.v1 : this.environment.api[type].v1;
		}
		
		return this.environment.api[type].v1;
	}
	
	getVendorDocumentId(
		dossier: DossierModel,
		parts_order: QuotationModel | PartsOrderModel,
		practice_id: string
	): Observable<string> {

		// let url: string = `${this.environment.AUTHORITY}/documents/registration_certificates?`;
		let url = this.getBaseURL(EModuleType.AUTHORITY, dossier || parts_order) + `/documents/registration_certificates?`;
		switch (true) {
			case !!(dossier && dossier.id):
				url += `dossier_id=${dossier.id}`;
				break;
			case !!(parts_order && parts_order.id):
				url += `parts_order_id=${parts_order.id}`;
				break;
			case !!practice_id:
				// url = `${this.environment.CARGLASS}/documents/${practice_id}/registration_certificates`;
				url = this.getBaseURL(EModuleType.CARGLASS, dossier) + `/documents/${practice_id}/registration_certificates?`;
				break;
		}
		return this.httpAuthService.get(
			url, this.redirectUrl
		).pipe(
			tap(response => {
				if (!response.ok) {
					throw response;
				}
			}),
			map(response => response.json().vendor_document_id),
			// tslint:disable-next-line:no-unnecessary-callback-wrapper
			catchError(err => throwError(err))
		);
	}

	downloadVendorDocument(
		vendor_document_id: string,
		item: DossierModel | CarglassRequestDetail | QuotationModel,
		is_car_glass: boolean = false
	): void {
		this.loaderService.display(true);

		const type = (item instanceof DossierModel || item instanceof QuotationModel) ? EModuleType.AUTHORITY : EModuleType.CARGLASS;
		let url = this.getBaseURL(type, item) + `/documents/registration_certificates/${vendor_document_id}`;

		this.httpAuthService.get(
			// `${is_car_glass ? this.environment.CARGLASS : this.environment.AUTHORITY}/documents/registration_certificates/${vendor_document_id}`,
			// `${this.getBaseURL(is_car_glass ? EModuleType.CARGLASS : EModuleType.AUTHORITY, item.isArchived())}/documents/registration_certificates/${vendor_document_id}`,
			url,
			this.redirectUrl,
			{responseType: ResponseContentType.Blob}
		).pipe(
			tap(response => {
				if (!response.ok) {
					throw response;
				}
			}),
			map(response => response.json()),
			// tslint:disable-next-line:no-unnecessary-callback-wrapper
			catchError(err => throwError(err))
		).subscribe(
			file_data => {
				Utilities.downloadBlob(
					file_data,
					`${DateUtilities.getStringDateFromDate(new Date()).split('-').join('')}_${this.registration_certificate}_${item.plate.trim()}`
				);
				this.loaderService.display(false);
			},
			error => {
				this.messageManagerService.pushInnerMessage(error);
				this.loaderService.display(false);
			}
		);
	}

	getActivityIdForDownloadQuotationPDF(dossier: DossierModel, working_id: string, quotation_id: string): Observable<{ id: string }> {

		// `${this.appConfig.Environment.AUTHORITY}/dossiers/${dossier.id}/workings/${working_id}/quotations/${quotation_id}/document_activities`,
		const url = this.getBaseURL(EModuleType.AUTHORITY, dossier) + `/dossiers/${dossier.id}/workings/${working_id}/quotations/${quotation_id}/document_activities`;
		return this.httpAuthService.post(url, {}, this.redirectUrl).pipe(
			tap(
				response => {
					if (!response.ok) {
						throw response;
					}
				}
			),
			map(response => response.json()),
			// tslint:disable-next-line:no-unnecessary-callback-wrapper
			catchError(err => throwError(err))
		);
	}

	downloadQuotationPdf(dossier: DossierModel, working_id: string, quotation_id: string, activity_id: string): Observable<any> {

	// `${this.appConfig.Environment.AUTHORITY}/dossiers/${dossier.id}/workings/${working_id}/quotations/${quotation_id}/activities/document_activities/${activity_id}/download`,
		const url = this.getBaseURL(EModuleType.AUTHORITY, dossier) + `/dossiers/${dossier.id}/workings/${working_id}/quotations/${quotation_id}/activities/document_activities/${activity_id}/download`;
		return this.httpAuthService.get(url, this.redirectUrl, {responseType: ResponseContentType.Blob}).pipe(
			tap(
				response => {
					if (!response.ok) {
						throw response;
					}
				}
			),
			map(response => response.json()),
			// tslint:disable-next-line:no-unnecessary-callback-wrapper
			catchError(err => throwError(err)
			)
		);
	}

	previewQuotationPdf(
		dossier_id: string, working_id: string, quotation_id: string
	): Observable<any> {
		return this.httpAuthService.get(
			`${this.appConfig.Environment.AUTHORITY}/dossiers/${dossier_id}/workings/${working_id}/quotations/${quotation_id}/consip_preview`,
			this.redirectUrl,
		).pipe(
			tap(
				response => {
					if (!response.ok) {
						throw response;
					}
				}
			),
			map(response => response.json()),
			// tslint:disable-next-line:no-unnecessary-callback-wrapper
			catchError(err => { 
				this.messageManagerService.pushInnerMessage(MessageManagerUtilities.getMessageDetailsFromResponse(err));
        this.loaderService.display(false);
				return throwError(err)
			})
		);
	}
}

enum EModuleType {
	AUTHORITY		= 'authority',
	CARGLASS		= 'carglass',
};